import { Trigger } from "@radix-ui/react-dropdown-menu";

export const DropdownMenuTrigger = Trigger;

/**
 * @deprecated
 *
 * use `DropdownMenuTrigger` instead
 */
export const DropdownTrigger = Trigger;
